<template>
  <div class="phone-input-v3">
    <label v-if="label" class="phone-input-v3_label">{{ label }}</label>
    <ac-phone-input
      class="phone-input-v3_input --no-border"
      :value="modelValue"
      :placeholder="placeholder"
      @on-input="onInputPhone($event)"
      @on-validate="onValidatePhone($event)"
      label=""
    />
    <div v-if="loading" class="input-v3_loader">
      <ac-preloader />
    </div>
  </div>
</template>
<script lang="ts" setup>
import AcPreloader from '@ui-kit/components/AcPreloader.vue'
import AcPhoneInput from '@ui-kit/components/AcPhoneInput.vue'

defineOptions({
  name: 'PhoneInputV3'
})

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
  required: {
    type: Boolean,
    default: false
  },
  maxlength: {
    type: Number
  },
  name: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'on-validate'])

type PhonePayload = {
  country: string
  countryCallingCode: string
  countryCode: string
  formatted: string
  getMetadata: () => void
  nationalNumber: string
  number: string
  possible: boolean
  valid: boolean
}

function getPhoneValue (payload: string | PhonePayload | null | undefined): string {
  if (!payload) return ''
  if (typeof payload === 'string') return payload
  return payload.number || payload.formatted || `${payload.countryCallingCode}${payload.nationalNumber}` || ''
}

function onInputPhone (payload: string | PhonePayload | null | undefined) {
  emit('update:modelValue', getPhoneValue(payload))
}

function onValidatePhone (payload: string | PhonePayload | null | undefined) {
  emit('on-validate', payload)
}

</script>

<style scoped lang="scss">
.phone-input-v3 {
  width: 100%;
  border-radius: 22px;
  padding: 7px 14px;
  border: 1px solid var(--ac-color-light-gray);
  font-family: Inter;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;

  &_loader {
    width: 16px;
    height: 16px;
  }

  &_label {
    color: var(--ac-color-gray);
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0.018px;
    padding: 0 8px;
    background-color: var(--ac-color-white);
    overflow: visible;
    position: absolute;
    top: -6px;
  }

  &_input {
    width: 100%;
    border: 0;
    outline: none;
    background: transparent;
    color: var(--ac-color-black);
    caret-color: var(--ac-color-black);
    transition: color .3s;
    appearance: textfield;
    -moz-appearance: textfield;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    caret-color: var(--ac-color-deep-navy-blue);

    &:placeholder {
      color: var(--ac-color-gray);
    }
  }
}
</style>
